export const receiverFields = [
  ['CountryCode', 'Country code', true], ['FirstName', 'Recipient name', true],
  ['Street', 'Street address', true], ['City', 'City', true],
];
export const declarationFields = [
  ['EName', 'English description'],
  ['UnitPrice', 'Declared value per item'], ['CurrencyCode', 'Currency (e.g. USD)'],
  ['UnitWeight', 'Weight per item (kg)'],
];
export function initialShipmentForm(row = {}) {
  return {channel: '', weight: '', declarationConfirmed: false, parcels: [], receiver: {
      CountryCode: row.AddressCountryCode || (row.ShippingCountry === 'United States' ? 'US' : ''),
      FirstName: row.ShippingName || '', Company: row.vaClinicName || row.vaHospitalName || '',
      Street: [row.Address1, row.Address2].filter(Boolean).join(', '), City: row.ShippingCity || '',
      State: row.ShippingProvinceCode || row.ShippingProvince || '', Zip: row.ShippingZip || '',
      Phone: row.ShippingPhone || '', Email: row.shippingEmail || row.customerEmail || '',
    }};
}
export function initialShipmentSelection(items) {
  return items.length === 1 && items[0].remainingQuantity === 1 ? {[items[0].ItemID]: 1} : {};
}
export function shipmentPayload(form, selection, eligible, requestKey) {
  if (Object.values(selection).some(q => !Number.isInteger(Number(q)) || Number(q) < 0)) throw Error('Use whole, non-negative item quantities.');
  const items = Object.entries(selection).filter(([, q]) => Number(q) > 0)
    .map(([ItemID, q]) => ({ItemID, quantity: Number(q)}));
  if (!items.length) throw Error('Select at least one item to ship.');
  for (const item of items) {
    const row = eligible.find(r => r.ItemID === item.ItemID);
    if (!row || !Number.isInteger(item.quantity) || item.quantity > row.remainingQuantity) throw Error('Check the selected quantities.');
  }
  for (const [key, label, required] of receiverFields) {
    if (required && !String(form.receiver[key] || '').trim()) throw Error(`Enter the recipient ${label.toLowerCase()}.`);
  }
  if (!/^[A-Z]{2}$/.test(form.receiver.CountryCode)) throw Error('Enter a two-letter country code.');
  if (!form.channel.trim()) throw Error('Select a shipping channel.');
  for (const key of ['weight']) {
    if (!(Number(form[key]) > 0) || !Number.isFinite(Number(form[key]))) throw Error(`Enter the package ${key}.`);
  }
  const parcels = items.map(item => {
    const parcel = form.parcels.find(p => p.ItemID === item.ItemID) || {};
    if (!parcel.EName?.trim() || !(Number(parcel.UnitPrice) > 0) ||
      !(Number(parcel.UnitWeight) > 0) || !/^[A-Z]{3}$/.test(parcel.CurrencyCode || '')) {
      throw Error(`Complete the customs declaration for ${item.ItemID}.`);
    }
    return {ItemID: item.ItemID, EName: parcel.EName.trim(), CurrencyCode: parcel.CurrencyCode,
      Quantity: item.quantity, UnitPrice: Number(parcel.UnitPrice), UnitWeight: Number(parcel.UnitWeight)};
  });
  if (!form.declarationConfirmed) throw Error('Confirm the address, customs values and battery classification.');
  return {channel:form.channel,weight:Number(form.weight),receiver:form.receiver,
    declarationConfirmed:form.declarationConfirmed,items,parcels,requestKey};
}
